<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr"
        id="contractor_favorite_form"
        max-width="580px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card>
            <v-card-title>
                {{ title }}
            </v-card-title>
            <v-card-text>
                <v-autocomplete
                    v-model="selectedPharmacistIds"
                    :items="activePharmacists"
                    :menu-props="{ closeOnContentClick: true }"
                    label="Benutzer"
                    id="select-pharmacists"
                    class="mt-4"
                    multiple
                    chips
                    dense
                />
                <v-list>
                    <v-list-item
                        v-for="pharmacist in savedPharmacists"
                        :data-id="pharmacist._id"
                        :key="pharmacist._id"
                    >
                        <v-list-item-content style="flex: none;">
                            <a :href="`/pharmacists/${pharmacist._id}`" target="_blank">
                                {{ pharmacist.lastname }}, {{ pharmacist.firstname }}
                            </a>
                        </v-list-item-content>
                        <v-list-item-action class="ml-auto">
                            <v-btn @click.stop="remove(pharmacist._id)" icon outlined small>
                                <v-icon small>mdi-close</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                </v-list>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                    @click="$emit('save', selectedPharmacistIds)"
                    id="save-pharmacists"
                    color="success"
                    depressed
                >
                    Speichern
                </v-btn>
                <v-btn @click="isOpen = false" outlined>Abbrechen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        value: Boolean,
        activePharmacists: Array,
        savedPharmacistIds: Array,
        title: String
    },
    emits: ['submit', 'remove'],

    data: function() {
        return {
            selectedPharmacistIds: [ ...this.savedPharmacistIds ],
        };
    },
    methods: {
        remove(pharmacistId) {
            this.selectedPharmacistIds = this.selectedPharmacistIds.filter(id => id !== pharmacistId);
            this.$emit('remove', pharmacistId)
        },
    },
    computed: {
        savedPharmacists() {
            return this.activePharmacists.filter(pharmacist => (
                this.selectedPharmacistIds.includes(pharmacist._id)
            ));
        },
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state)
            }
        },
    },
}
</script>
